import { ORDERS } from "../actionTypes";
import {
    placeUserSipOrders, cancelUserSipOrders, getUserSipSettingDetails, getUserSipOrderHistory, scripFromInstandExchangeDetails, dynamicProductTypes,
    placeUserSingleScripOrders, getSriptForSecondLeg, placeMultilegOrder, placeMultiScriptOrderCart, orderCartMultiScript, getSpreadOrderInfo, getUserMultiScripOrders, placeUserSingleScripCoverOrders, placeUserSingleScripBracketOrders, orderMarginInfo, cancelSingleOrders, cancelAllOrders, modifysingleScripOrder, cancelAllSipOrders,
    setCautionaryMsgDetails,
    eqSipScripMaster
} from '../../apis';
import { convertScripResponseWatchlistGrid, deepClone, getStorageWithMultiTabCheck } from '../../utils/global_functions';
import { WATCHLIST_GRID_INDEX, SCRIP_INSTRUMENTS, API_SOURCE, ORDERBOOK_API_ORDER_STATUS, ORDERS_TABKEY, LOCAL_STORAGE_KEYS, productDetails, FACILITY_NUM } from '../../utils/global_variables';
import { _getAllSipOrders, _updateSipOrder, _getAllOpenOrders, _getBannedScripStatus, _getLTPPriceBand, _getMarginPlusParams, _getMarketStatus, _getProductType, _getBannedScripsList } from "../../controllers";
import moment from "moment";
import { _getAllOrders, _getGtdOrders, _getSortedOrders, _getTradeOrders } from "../../controllers/orders";
import { cancelAllMultilegOrders, modifySpreadOrder, modifyUserSingleScripCoverOrders, modifyUserSingleScripBracketOrders } from "../../apis/transactional";

//start
export const getExchangeWiseScripInfo = (scripInfo) => async (dispatch, getState) => {
    try {
        const objLoginSession = deepClone(getState()?.auth?.objLoginSession?.data);
        let obj = { strInstrument: scripInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]?.replace(/\s+/g, '').toUpperCase() || scripInfo?.instrument?.replace(/\s+/g, '').toUpperCase(), strSymbol: scripInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]?.replace(/\s+/g, '').toUpperCase() || scripInfo?.title?.replace(/\s+/g, '').toUpperCase() };
        const objResp = await scripFromInstandExchangeDetails(obj);
        let arrAllExchangesScrips = objResp?.data?.result?.hits?.hits?.map(scrip => scrip?._source);
        arrAllExchangesScrips = arrAllExchangesScrips?.filter(objScrip => objLoginSession?.exchanges?.includes(objScrip?.ExchangeSegment) || objLoginSession?.bcastExchanges?.includes(objScrip?.ExchangeSegment));
        if (scripInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] !== SCRIP_INSTRUMENTS.EQUITIES) {
            arrAllExchangesScrips = arrAllExchangesScrips?.filter(objScrip => objScrip?.MktSegId === scripInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] && objScrip?.nToken === scripInfo?.[WATCHLIST_GRID_INDEX.TOKEN]);
        } else { }
        const arrConvertedAllExchangesScrips = arrAllExchangesScrips?.length > 0 ? convertScripResponseWatchlistGrid(arrAllExchangesScrips) : Array.isArray(scripInfo) ? [scripInfo] : [];
        dispatch(getExchangeWiseScripInfoSuccess(arrConvertedAllExchangesScrips));
        return Promise.resolve(objResp);
    }
    catch (error) {
        console.error(error);
        dispatch(getExchangeWiseScripInfoFailure([]));
        return Promise.reject(error);
    }
};

export const updateMultiScripaddLEgModalTabKeyAction = (payload) => {
    return { type: ORDERS?.UPDATE_MULTILEG_ADD_LEG_MODAL_ACTIVE_TAB, payload };
};

export const updateOrderSingleScripColdef = (payload) => {
    return { type: ORDERS?.UPDATE_ORDER_SINGLE_SCRIP_COL_DEF, payload };
};

export const getGtdColdefColumnDefs = () => async (dispatch) => {
    try {
        const objResp = [
            { headerName: "TIME & DATE", field: "order_timestamp" },
            { headerName: "SCRIP NAME", field: "title" },
            { headerName: "LTP", field: "ltp" },
            { headerName: "STATUS", field: "status" },
            { headerName: "BUY/SELL", field: "transaction_type" },
            { headerName: "QUANTITY", field: "total_quantity" },
            { headerName: "PRICE", field: "order_price" },
            { headerName: "PRODUCT TYPE", field: "prodTypeDesc" },
            { headerName: "ORDER TYPE", field: "order_type" },
            { headerName: "VALIDITY", field: "validity" },
            { headerName: "GTD DATE", field: "validity_date" },
            { headerName: "EXCHANGE DATE TIME", field: "order_timestamp" },
            { headerName: "EXCHANGE ORDER NO", field: "exchange_order_no" },
            { headerName: "INITIATED BY", field: "initiated_by" },
            { headerName: "MODIFIED BY", field: "modified_by" },
        ];
        dispatch(updateGtdColdef(objResp));
    } catch (error) {
        console.error(error);
        dispatch(updateGtdColdef([]));

    }
};


export const updateGtdColdef = (payload) => {
    return { type: ORDERS?.UPDATE_GTD_COL_DEF, payload };
};


export const updateMultiLegColdef = (payload) => {
    return { type: ORDERS?.UPDATE_MULTI_LEG_COL_DEF, payload };
};

export const updateEquitySipColdef = (payload) => {
    return { type: ORDERS?.UPDATE_EQUITY_SEIP_COL_DEF, payload };
};


export const updateSpreadColdef = (payload) => {
    return { type: ORDERS?.UPDATE_SPREAD_COL_DEF, payload };
};

export const getExchangeWiseScripInfoSuccess = (payload) => {
    return { type: ORDERS.GET_EXCHANGE_WISE_SCRIP_INFO_SUCCESS, payload };
};
export const getExchangeWiseScripInfoFailure = (payload) => {
    return { type: ORDERS.GET_EXCHANGE_WISE_SCRIP_INFO_FAILURE, payload };
};

export const getProductTypes = () => async (dispatch) => {
    try {
        const objResp = await dynamicProductTypes();
        dispatch(getProductTypesSuccess([...objResp?.data?.result]));
        return Promise.resolve([...objResp?.data?.result]); //BREEZE-16 : Order Slicing Feature : ManasaB : 17-11-2024 : Reorder issue for carryforward product type,changes done by Azeem
    }
    catch (error) {
        console.error(error);
        dispatch(getProductTypesFailure());
        return Promise.resolve([]);//BREEZE-16 : Order Slicing Feature : ManasaB : 17-11-2024 : Reorder issue for carryforward product type,changes done by Azeem
    }
};
export const getEqSipScripMaster = () => async (dispatch) => {
    try {
        const objResp = await eqSipScripMaster();
        dispatch(getEqSipScripMasterSuccess(objResp?.data?.data));
    }
    catch (error) {
        dispatch(getEqSipScripMasterFailure({}));
        console.error(error);
    }
};

export const getEqSipScripMasterSuccess = (objResp) => {
    return { type: ORDERS.GET_EQSIP_SCRIP_MASTER_SUCCESS, payload: objResp };
};
export const getEqSipScripMasterFailure = (payload) => {
    return { type: ORDERS.GET_EQSIP_SCRIP_MASTER_FAILURE, payload };
};
export const getProductTypesSuccess = (objResp) => {
    return { type: ORDERS.GET_DYNAMIC_PRODUCT_TYPES_SUCCESS, payload: objResp };
};
export const getProductTypesFailure = (payload) => {
    return { type: ORDERS.GET_DYNAMIC_PRODUCT_TYPES_FAILURE, payload };
};
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

export const placeSingleScripOrder = (objpayload) => async (dispatch) => {
    //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - Star
    dispatch(orderEntryApiPending(true));
    //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - End
    try {
        const res = await placeUserSingleScripOrders(objpayload);
        dispatch(placeSingleScripOrderSuccess(res.data));

        // Temp MAAZ - for Testing - Start
        // dispatch(placeSingleScripOrderSuccess({
        //     "status": "success",
        //     "code": "s-101",
        //     "message": "Order Entry Sent to OMS",
        //     "data": {
        //         "orderId": "NXWDE0001418"
        //     }
        // }));
        // Temp MAAZ - for Testing - End
    } catch (error) {
        console.error(error);
        if (error?.response?.data) {
            dispatch(placeSingleScripOrderFailure(error?.response?.data));
        } else {
            dispatch(placeSingleScripOrderFailure({}));
        }
        //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - Start
    } finally {
        dispatch(orderEntryApiPending(false));
    }
    //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - End
};

export const placeSingleScripCoverOrder = (objpayload) => async (dispatch) => {
    dispatch(orderEntryApiPending(true));
    try {
        const objResp = await placeUserSingleScripCoverOrders(objpayload);
        dispatch(placeSingleScripOrderSuccess(objResp?.data));
    } catch (error) {
        console.error(error);
        if (error?.response?.data) {
            dispatch(placeSingleScripOrderFailure(error?.response?.data));
        } else {
            dispatch(placeSingleScripOrderFailure({}));
        }
    } finally {
        dispatch(orderEntryApiPending(false));
    }
};

export const placeSingleScripBracketOrder = (objpayload) => async (dispatch) => {
    try {
        const res = await placeUserSingleScripBracketOrders(objpayload);
        dispatch(placeSingleScripOrderSuccess(res.data));
    } catch (error) {
        console.error(error);
        if (error?.response?.data) {
            dispatch(placeSingleScripOrderFailure(error?.response?.data));
        } else {
            dispatch(placeSingleScripOrderFailure({}));
        }
    }
};

export const placeSingleScripOrderSuccess = (payload) => {
    return { type: ORDERS.PLACE_SINGLESCRIP_ORDER_SUCCESS, payload };
};
export const placeSingleScripOrderFailure = (payload) => {
    return { type: ORDERS.PLACE_SINGLESCRIP_ORDER_FAILURE, payload };
};

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

// Neha's Actions end
//Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
export const getAllOrders = (objOrderBookPayload) => async (dispatch, getState) => {
    dispatch(ordersApiPending(true));
    try {

        //    DontMiss Logic commented as BA (Mithun) suggested dontMiss will not show for orders
        // const whatsHotData = getState().dontMiss?.whatsHotData;
        // let arrWhatsHotData = [];
        // if (whatsHotData?.length > 0) {
        //     arrWhatsHotData = whatsHotData;
        // } else {
        //     const arrWhatsHotDataFromApi = await _getWhatsHotData();
        //     arrWhatsHotData = arrWhatsHotDataFromApi?.data.data.result;
        //     dispatch(getWhatsHotDataSuccess(arrWhatsHotDataFromApi?.data.data.result));
        // }
        //BREEZE-16 : Order Slicing Feature : ManasaB : 17-11-2024 : Reorder issue for carryforward product type,changes done by Azeem - Start
        let productTypeData = getState()?.orders?.productTypes;
        if (productTypeData?.length < 1) {
            productTypeData = await dispatch(getProductTypes());
        }
        //BREEZE-16 : Order Slicing Feature : ManasaB : 17-11-2024 : Reorder issue for carryforward product type,changes done by Azeem - End
        const objLoginSession = JSON?.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
        const { data, status } = await _getAllOrders(objOrderBookPayload, productTypeData, objLoginSession); //(arrWhatsHotData will) be second argument if dontMiss Applicable
        const { orderStatus } = objOrderBookPayload;
        switch (orderStatus) {
            case ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS: {
                if (status) {
                    if (+objOrderBookPayload?.offSet > 1) {
                        if (data?.arrOrders?.length > 0) {
                            dispatch(updateSingleScripAllOrders(data?.arrOrders));
                        } else {
                            dispatch(updateSingleScripAllOrders([]));
                        }
                    } else {
                        dispatch(getAllOrdersSuccess(data?.arrOrders));
                        dispatch(setCurrentPage(1));

                    }
                    dispatch(getAllSingleScripOrdersLength(data?.objOrdersLength?.all_records));
                    dispatch(getOpenSingleScripOrdersLength(data?.objOrdersLength?.open_records));
                    dispatch(getCompletedSingleScripOrdersLength(data?.objOrdersLength?.completed_records));
                } else {
                    dispatch(getAllOrdersSuccess([]));
                    dispatch(getAllSingleScripOrdersLength(0));
                }

                break;
            }
            case ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS: {
                if (status) {
                    if (+objOrderBookPayload?.offSet > 1) {
                        if (data?.arrOrders?.length > 0) {
                            dispatch(updateSingleScripOpenOrders(data?.arrOrders));
                        } else {
                            dispatch(updateSingleScripOpenOrders([]));
                        }
                    } else {
                        dispatch(getAllOpenOrderSuccess(data?.arrOrders));
                        dispatch(setCurrentPage(1));

                    }
                    dispatch(getAllSingleScripOrdersLength(data?.objOrdersLength?.all_records));
                    dispatch(getOpenSingleScripOrdersLength(data?.objOrdersLength?.open_records));
                    dispatch(getCompletedSingleScripOrdersLength(data?.objOrdersLength?.completed_records));
                } else {
                    dispatch(getAllOpenOrderFailure([]));
                    dispatch(getOpenSingleScripOrdersLength(0));

                }

                break;
            }
            case ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS: {
                if (status) {
                    if (+objOrderBookPayload?.offSet > 1) {
                        if (data?.arrOrders?.length > 0) {
                            dispatch(updateSingleScripCompletedOrders(data?.arrOrders));
                        } else {
                            dispatch(updateSingleScripCompletedOrders([]));
                        }
                    } else {
                        dispatch(getAllCompletedOrderSuccess(data?.arrOrders));
                        dispatch(setCurrentPage(1));

                    }
                    dispatch(getAllSingleScripOrdersLength(data?.objOrdersLength?.all_records));
                    dispatch(getOpenSingleScripOrdersLength(data?.objOrdersLength?.open_records));
                    dispatch(getCompletedSingleScripOrdersLength(data?.objOrdersLength?.completed_records));
                } else {
                    dispatch(getAllCompletedOrderFailure([]));
                    dispatch(getCompletedSingleScripOrdersLength(0));

                }
                break;
            }
            default:
                break;
        }
        if (status) {

            return Promise.resolve({ status, data });
        } else {
            return Promise.reject([]);
        }
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(ordersApiPending(false));

    }
};
//Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End


export const updateOrderTypes = (objOrderType) => {

    return { type: ORDERS.UPDATE_ORDER_TYPES, payload: objOrderType };
};


export const updateSpreadOrderInfo = (payload) => {
    return { type: ORDERS?.UPDATE_SPREAD_ORDER_INFO, payload };
};


export const getAllOrdersSuccess = (arrAllOrders) => {
    return { type: ORDERS.UPDATE_ALL_ORDERS, payload: arrAllOrders };
};

export const getAllOrderFailure = (arrAllOrders) => {
    return { type: ORDERS.UPDATE_ALL_ORDERS, payload: arrAllOrders };
};

export const handleSpreadSideOrder = (payload) => {
    return { type: ORDERS.HANDLE_SPREAD_SIDE_ORDER, payload };
};


export const getAllCompletedOrderSuccess = (payload) => {
    return { type: ORDERS.GET_COMPLETED_ORDERS_SUCCESS, payload: payload };
};

export const getAllCompletedOrderFailure = (payload) => {
    return { type: ORDERS.GET_COMPLETED_ORDERS_FAILURE, payload: payload };
};
export const getAllOpenOrderSuccess = (payload) => {
    return { type: ORDERS.GET_OPEN_ORDERS_SUCCESS, payload: payload };
};
export const getAllOpenOrderFailure = (payload) => {
    return { type: ORDERS.GET_OPEN_ORDERS_FAILURE, payload: payload };
};

export const updateAllOrders = (arrAllOrders) => {
    return { type: ORDERS.UPDATE_ALL_ORDERS, payload: arrAllOrders };
};
export const getScripOrderInfo = (payload) => {
    return { type: ORDERS.GET_SCRIP_ORDER_INFO, payload };
};
//Vaibhav Singh: 05-02-24: BT-104814: Added filter object
export const updateFilters = (objFilter) => {
    return { type: ORDERS.SET_FILTER, payload: objFilter };
};
export const updateActiveOrders = (active) => {
    return { type: ORDERS.UPDATE_ACTIVE_ORDERS, payload: active };
};
// export const getBrokerageCharges = () => {
//     return { type: ORDERS.GET_BROKERAGE_CHARGES, payload: {} };
// }

export const placeSipOrder = (objpayload) => async (dispatch) => {
    // {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - Start */ }
    try {
        dispatch(orderEntryApiPending(true));
        const resp = await placeUserSipOrders(objpayload);
        dispatch(placeSipOrderSuccess(resp?.data));
    } catch (error) {
        console.error(error);
        dispatch(placeSipOrderFailure({}));
    } finally {
        dispatch(orderEntryApiPending(false));
    }
    // {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - End */ }
};
export const placeSipOrderSuccess = (resp) => {
    return { type: ORDERS.PLACE_SIP_ORDER_SUCCESS, payload: resp };

};
export const placeSipOrderFailure = (payload) => {
    return { type: ORDERS.PLACE_SIP_ORDER_FAILURE, payload };
};
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
export const getAllSipOrders = (objSipOrderPayload, isHistoryAllowed) => async (dispatch, getState) => {
    const arrAllSipOrders = deepClone(getState()?.orders?.arrAllSipOrders);
    const arrOpenSipOrders = deepClone(getState()?.orders?.arrOpenSipOrders);
    const arrCompletedSipOrders = deepClone(getState()?.orders?.arrCompletedSipOrders);
    dispatch(ordersApiPending(true));
    try {
        // _getAllSipOrders;
        // const arrWhatsHotData = await whatsHotData();
        // dispatch(getWhatsHotDataSuccess(arrWhatsHotData?.data?.result));
        const objResp = await _getAllSipOrders(objSipOrderPayload, isHistoryAllowed);

        const { orderStatus } = objSipOrderPayload;

        switch (orderStatus) {
            case ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS: {
                if (objResp?.status) {
                    if (+objSipOrderPayload?.offSet > 1) {
                        if (objResp?.data?.arrOrders?.length > 0) {
                            dispatch(updateAllSipOrders(_getSortedOrders([...arrAllSipOrders, ...objResp?.data?.arrOrders])));
                            dispatch(updateAllSipOrdersCount(objResp?.data?.metadata));
                        } else {
                            dispatch(updateAllSipOrders([]));
                        }
                    } else {
                        dispatch(getAllSipOrderSuccess(objResp?.data?.arrOrders));
                        dispatch(updateAllSipOrdersCount(objResp?.data?.metadata));
                        dispatch(setCurrentPage(1));

                    }

                } else {
                    dispatch(getAllSipOrderFailure([]));
                }

                break;
            }
            case ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS: {
                if (objResp?.status) {
                    if (+objSipOrderPayload?.offSet > 1) {
                        if (objResp?.data?.arrOrders?.length > 0) {
                            dispatch(updateOpenSipOrders(_getSortedOrders([...arrOpenSipOrders, ...objResp?.data?.arrOrders])));
                            dispatch(updateAllSipOrdersCount(objResp?.data?.metadata));

                        } else {
                            dispatch(updateOpenSipOrders([]));
                        }
                    } else {
                        dispatch(getOpenSipOrdersSuccess(objResp?.data?.arrOrders));
                        dispatch(updateAllSipOrdersCount(objResp?.data?.metadata));

                        dispatch(setCurrentPage(1));

                    }

                } else {
                    dispatch(getOpenSipOrdersFailure([]));

                }

                break;
            }
            case ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS: {
                if (objResp?.status) {
                    if (+objSipOrderPayload?.offSet > 1) {
                        if (objResp?.data?.arrOrders?.length > 0) {
                            dispatch(updateCompletedSipOrders(_getSortedOrders([...arrCompletedSipOrders, ...objResp?.data?.arrOrders])));
                            dispatch(updateAllSipOrdersCount(objResp?.data?.metadata));

                        } else {
                            dispatch(updateCompletedSipOrders([]));
                        }
                    } else {
                        dispatch(getCompletedSipOrdersSuccess(objResp?.data?.arrOrders));
                        dispatch(updateAllSipOrdersCount(objResp?.data?.metadata));

                        dispatch(setCurrentPage(1));

                    }
                } else {
                    dispatch(getCompletedSipOrdersFailure([]));

                }
                break;
            }
            default:
                break;
        }
        if (objResp?.status) {

            return Promise.resolve({ status: objResp?.status, data: objResp?.data?.arrOrders });
        } else {
            return Promise.reject([]);
        }
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(ordersApiPending(false));

    }
};
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

export const getAllSipOrderSuccess = (resp) => {
    return { type: ORDERS.GET_ALL_SIP_ORDERS_SUCCESS, payload: resp };

};
export const getAllSipOrderFailure = (payload) => {
    return { type: ORDERS.GET_ALL_SIP_ORDERS_FAILURE, payload };

};
// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
export const updateSipOrder = (objupdateSipOrderPayload) => async (dispatch) => {
    try {
        const objResp = await _updateSipOrder(objupdateSipOrderPayload, API_SOURCE.BREEZE);
        if (objResp?.status) {
            dispatch(updateSipOrderSuccess(objResp));
        } else { }
        return Promise.resolve(objResp);
    } catch (error) {
        console.error(error);
    }


};
// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End


export const updateSipOrderSuccess = (resp) => {
    return { type: ORDERS.UPDATE_SIP_ORDER_SUCCESS, payload: resp };
};

export const updateSipOrderFailure = (payload) => {
    return { type: ORDERS.UPDATE_SIP_ORDER_FAILURE, payload };
};

// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
export const cancelSipOrder = (data) => async (dispatch) => {
    try {
        const resp = await cancelUserSipOrders(data, API_SOURCE.BREEZE);
        dispatch(cancelSipOrderSuccess(resp));
        return Promise.resolve(resp);
    } catch (error) {
        console.error(error);
    }
};
// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
export const cancellMultipleSipOrders = (objPayload) => async () => {
    try {
        const objResp = cancelAllSipOrders(objPayload);
        return Promise.resolve(objResp);
    } catch (error) {
        console.error(error);
        return Promise.reject();
    }

};
// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

export const cancelAllMultipleMultiLegOrders = (objPayload) => async () => {
    try {
        const objResp = cancelAllMultilegOrders(objPayload);
        return Promise.resolve(objResp);
    } catch {
        return Promise.reject();
    }
};

export const cancelSipOrderSuccess = (payload) => {
    return { type: ORDERS.CANCEL_SIP_ORDER_SUCCESS, payload };
};
export const cancelSipOrderFailure = (payload) => {
    return { type: ORDERS.CANCEL_SIP_ORDER_FAILURE, payload };
};

export const getSipSettingDetails = () => async (dispatch) => {
    try {
        const resp = await getUserSipSettingDetails();
        dispatch(getSipSettingDetailsSuccess(resp?.data?.data));
    } catch (error) {
        console.error(error);
    }


};
export const updateMultilLegDataForBrokerag = (payload) => {
    return { type: ORDERS.MULTILEG_DATA_FOR_BROKERAGE, payload };
};
export const getSipSettingDetailsSuccess = (resp) => {
    return { type: ORDERS.GET_SIP_SETTING_DETAILS_SUCCESS, payload: resp };
};
export const getSipSettingDetailsFailure = (payload) => {
    return { type: ORDERS.GET_SIP_SETTING_DETAILS_FAILURE, payload };
};
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
export const getSipOrderHistory = (payload, ordersTabKey) => async (dispatch, getState) => {
    const { orders: { getSipOrder } } = getState();
    const arrAllSipOrders = getState()?.orders?.arrAllSipOrders;
    const arrOpenSipOrders = getState()?.orders?.arrOpenSipOrders;
    const arrCompletedSipOrders = getState()?.orders?.arrCompletedSipOrders;
    let arrOrderHistory = [];
    try {
        let arrOrders = [];
        if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
            arrOrders = [...arrAllSipOrders];
        } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
            arrOrders = [...arrOpenSipOrders];
        } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) {
            arrOrders = [...arrCompletedSipOrders];

        }

        const resp = await getUserSipOrderHistory(payload);
        arrOrderHistory = resp?.data?.data;
        const nOrderIndex = arrOrders.findIndex(order => order?.id === payload?.id);
        arrOrders[nOrderIndex].orderHistory = arrOrderHistory;

        if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS && arrOrderHistory?.length > 0) {
            dispatch(getAllSipOrderSuccess(arrOrders));

        } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS && arrOrderHistory?.length > 0) {
            arrOrders = [...arrOpenSipOrders];
            dispatch(getOpenSipOrdersSuccess(arrOrders));

        } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS && arrOrderHistory?.length > 0) {
            dispatch(getCompletedSipOrdersSuccess(arrOrders));

        }


    } catch (error) {
        console.error(error);
    }

};
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End


export const getSipOrderHistorySuccess = (resp) => {
    return { type: ORDERS.GET_SIP_ORDER_HISTORY_SUCCESS, payload: resp };
};
export const getSipOrderHistoryFailure = (payload) => {
    return { type: ORDERS.GET_SIP_ORDER_HISTORY_FAILURE, payload };
};

export const getOrderMarginInfo = (arrLegDetails) => async (dispatch, getState) => {
    try {
        dispatch(updateIsLoadingMarginInfo(true));
        const objLoginSession = deepClone(getState()?.auth?.objLoginSession);
        const objReqPayload = {
            UserID: objLoginSession?.data?.user_id,
            GroupID: objLoginSession?.data?.others?.groupId,
            GroupCode: objLoginSession?.data?.others?.groupCode,
            UCCClientID: "",
            UCCGroupID: "",
            NoOfLegs: arrLegDetails.length, //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024
            Mode: "N",
            TemplateId: "DIET",
            UserCode: objLoginSession?.data?.others?.userCode,
            FETraceId: objLoginSession?.data?.user_id + "_" + moment().format('ddmmyyHHMMss'),
            LegDetails: arrLegDetails
        };
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024  - Start
        if (arrLegDetails.length > 1) {
            objReqPayload["MessageType"] = "FUND_BASKET_UTIL_REQ";
            delete objReqPayload.Mode;
        }
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 - End
        const objResp = await orderMarginInfo(objReqPayload);
        const objMarginResult = deepClone(objResp?.data?.data?.result);
        //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start
        objMarginResult.ApproxMargin = objResp?.data?.data?.result?.ApproxMargin;
        objMarginResult.AvailableMargin = objResp?.data?.data?.result?.AvailableMargin;
        //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End
        dispatch(orderMarginInfoSuccess(objMarginResult));
        dispatch(updateIsLoadingMarginInfo(false));
        return Promise?.resolve(objResp);
    } catch (error) {
        console.error(error);
        dispatch(orderMarginInfoFailure([]));
        dispatch(updateIsLoadingMarginInfo(false));
        return Promise?.reject(error);
    }
};

export const updateIsLoadingMarginInfo = (payload) => {
    return { type: ORDERS.UPDATE_IS_LOADING_ORDER_MARGIN_INFO, payload };
};

export const orderMarginInfoSuccess = (objResp) => {
    return { type: ORDERS.GET_ORDER_MARGIN_INFO_SUCCESS, payload: objResp };
};

export const orderMarginInfoFailure = (payload) => {
    return { type: ORDERS.GET_ORDER_MARGIN_INFO_FAILURE, payload };
};
export const getHorizontalScripPrice = (payload) => {
    return { type: ORDERS.GET_HORIZONTAL_SCRIP_PRICE, payload };
};

export const getTradeOrders = (objOrderBookPayload) => async (dispatch, getState) => {
    const { orders: { allOrders } } = getState();
    try {
        const objResp = await _getTradeOrders(objOrderBookPayload, allOrders);
        if (objResp?.data?.arrTradeOrders?.length > 0) {
            dispatch(updateAllOrders(objResp?.data?.arrAllOrders));
        }


    } catch (error) {
        console.error(error);
        dispatch(updateAllOrders(allOrders));
    }

};
// Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
export const getSingleScripOrderColumnDefs = () => async (dispatch) => {
    try {
        const objResp = [
            { field: 'time', headerName: "DATE & TIME" },
            { field: 'title', headerName: "SCRIP NAME" },
            { field: 'ltp', headerName: "LTP" },
            { field: 'status', headerName: "STATUS" },
            { field: 'type', headerName: "BUY/SELL" },
            { field: 'qty', headerName: "QUANTITY" },
            // { field: 'disclosed_quantity', headerName: "DISCLOSED QTY" },
            { field: 'price', headerName: "PRICE", },
            { field: 'productTypeDesc', headerName: "PRODUCT TYPE", },
            { field: 'orderType', headerName: "ORDER TYPE" },
            { field: 'validity', headerName: "VALIDITY" },
            { field: 'averagePrice', headerName: "AVERAGE PRICE" },
            { field: 'trigger_price', headerName: "STOP LOSS" },
            { field: 'exchangeDateTime', headerName: "EXCHANGE DATE TIME" },
            { field: 'exchangeOrderNumber', headerName: "EXCHANGE ORDER NO" },
            { field: 'initiated_by', headerName: "INITIATED BY" },
            { field: 'modified_by', headerName: "MODIFIED BY" },
        ];
        dispatch(getSingleScripOrderColumnDefsSuccess(objResp));
    } catch (error) {
        console.error(error);
        dispatch(getSingleScripOrderColumnDefsFailure([]));

    }
};
// Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End

export const getSingleScripOrderColumnDefsSuccess = (payload) => {
    return { type: ORDERS.GET_SINGLE_SCRIP_ORDER_COLUMNDEFS_SUCCESS, payload: payload };

};
export const getSingleScripOrderColumnDefsFailure = (payload) => {
    return { type: ORDERS.GET_SINGLE_SCRIP_ORDER_COLUMNDEFS_FAILURE, payload: payload };

};

// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
export const getSipEquityOrderColumnDefs = () => async (dispatch) => {
    try {
        const objResp = [
            { field: 'time', headerName: 'DATE & TIME', pinned: 'left' },
            { field: 'symbol', headerName: "SCRIP NAME" },
            { field: 'id', headerName: 'SIP ID' },
            { field: 'ltp', headerName: "LTP", },
            { field: 'status', headerName: "STATUS", },
            { field: 'transaction_type', headerName: " TRANSACTION TYPE", },
            { field: 'investment_type', headerName: "INVEST BY", },
            { field: 'invested_qty_or_val', headerName: "QTY/VALUE", },
            { field: 'price', headerName: "PRICE" },
            { field: 'cap_price', headerName: "CAP PRICE", },
            { field: 'frequency_type', headerName: "FREQUENCY TYPE" },
            { field: 'frequency_details', headerName: "FREQUENCY DETAILS", },
            { field: 'executed_and_numberof_installment', headerName: "NO. OF INSTALLMENT", },
            { field: 'completed_installments', headerName: "INSTALLMENTS COMPLETED", },
            { field: 'rejected_installments', headerName: "FAILED INSTALLMENTS", },
            { field: 'created_date', headerName: "REQUEST DATE", },
            { field: 'frequency_start_date', headerName: "START DATE" },
            { field: 'installment_date', headerName: "NEXT EXECUTION DATE", },
            { field: 'investment_value', headerName: "INVESTED VALUE", },
            { field: 'created_by', headerName: "INITIATED FROM" },
            { field: 'modified_by', headerName: "MODIFIED FROM" },
        ];
        dispatch(getSipEquityOrderColumnDefsSuccess(objResp));
    } catch (error) {
        dispatch(getSipEquityOrderColumnDefsFailure([]));
        console.error(error);

    }
};
// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

export const getSipEquityOrderColumnDefsSuccess = (payload) => {
    return { type: ORDERS.GET_SIP_EQUITY_ORDERBOOK_COLUMNS_SUCCESS, payload: payload };

};
export const getSipEquityOrderColumnDefsFailure = (payload) => {
    return { type: ORDERS.GET_SIP_EQUITY_ORDERBOOK_COLUMNS_FAILURE, payload: payload };
};
export const getMultiLegOrderColumnDefs = () => async (dispatch) => {
    try {
        const objResp = [
            { headerName: "DATE & TIME", field: 'order_timestamp', pinned: 'left' },
            { headerName: "SCRIP NAME", field: 'spread_symbol', pinned: 'left' },
            { headerName: "STATUS", field: "status", filter: 'agTextColumnFilter' },
            { headerName: "FIRST LEG SYMBOL", field: 'leg_no_1.symbol' },
            { headerName: "FIRST LEG B/S", field: "leg_no_1.transaction_type", valueFormatter: params => params.data.leg_no_1?.transaction_type },
            { headerName: "FIRST LEG QTY", field: "leg_no_1.total_quantity" },//Azeem K:25-04-2024: change headerName QTY to QTY / LOT
            { headerName: "FIRST LEG PRICE", field: "leg_no_1.order_price", },
            { headerName: "SECOND LEG SYMBOL", field: 'leg_no_2.symbol' },
            { headerName: "SECOND LEG  B/S", field: "leg_no_2.transaction_type", valueFormatter: params => params.data.leg_no_2?.transaction_type },
            { headerName: "SECOND LEG  QTY", field: "leg_no_2.total_quantity" },
            { headerName: "SECOND LEG  PRICE", field: "leg_no_2.order_price", },
            { headerName: "THIRD LEG  SYMBOL", field: 'leg_no_3.symbol', },
            { headerName: "THIRD LEG  B/S", field: "leg_no_3.transaction_type", valueFormatter: params => params.data.leg_no_3?.transaction_type },
            { headerName: "THIRD LEG  QTY", field: "leg_no_3.total_quantity" },
            { headerName: "THIRD LEG  PRICE", field: "leg_no_3.order_price", },
            { headerName: "EXCHANGE ORDER NO", field: "leg_no_1.exchange_order_no", filter: 'agNumberColumnFilter' },
            { headerName: "PRODUCT TYPE", field: "prod_type", filter: 'agNumberColumnFilter' },
            { headerName: "VALIDITY", field: "validity", filter: 'agTextColumnFilter' },
            { headerName: "INITIATED FROM", field: "initiated_by", filter: 'agTextColumnFilter' },
            { headerName: "MODIFIED FROM", field: "modified_by", filter: 'agTextColumnFilter' },
        ];
        dispatch(getMultiLegOrderColumnDefsSuccess(objResp));
    } catch (error) {
        console.error(error);
        dispatch(getMultiLegOrderColumnDefsFailure([]));

    }


};
export const getMultiLegOrderColumnDefsSuccess = (payload) => {
    return { type: ORDERS.GET_MULTI_LEG_ORDER_COLUMNDEFS_SUCCESS, payload: payload };

};
export const getMultiLegOrderColumnDefsFailure = (payload) => {
    return { type: ORDERS.GET_MULTI_LEG_ORDER_COLUMNDEFS_FAILURE, payload: payload };

};
/*Parshva S: 26-10-2023 : BT-120114 - Breeze - Order Book - Spread - Start*/
export const getSpreadOrderColumnDefs = () => async (dispatch) => {
    try {
        const objResp = [
            // { headerName: 'check' },
            { headerName: "", field: "order_id", hide: true },
            // { headerName: "", field: "expandCell" },
            { headerName: "DATE & TIME", field: "order_modified_timestamp" },
            // { headerName: "Symbol", field: "spread_symbol" },
            // { headerName: "LEGS", field: "leg_indicator" },
            { headerName: "SCRIP NAME", field: 'leg_no_1.symbol' },
            { headerName: "STATUS", field: "status" },
            { headerName: "QUANTITY", field: "quantity" },//Azeem K:25-04-2024: change headerName QTY to QTY / LOT
            { headerName: "LTP", field: "ltp" },
            { headerName: "PRICE", field: "leg_no_1.order_price" },
            { headerName: "PROD TYPE", field: "prod_type" },
            { headerName: "VALIDITY", field: "validity" },
            { headerName: "FIRST LEG B/S", field: "leg_no_1.transaction_type", valueFormatter: params => params.data.leg_no_1?.transaction_type },
            // { headerName: "FIRST LEG EXPIRY", field: 'leg_no_1.expiry_date', valueFormatter: params => params.data.leg_no_1?.expiry_date },
            // { headerName: "FIRST LEG PRICE", field: 'leg_no_1.order_price', valueFormatter: params => params.data.leg_no_1?.order_price },
            { headerName: "SECOND LEG B/S", field: "leg_no_2.transaction_type", valueFormatter: params => params.data.leg_no_2?.transaction_type },
            // { headerName: "SECOND LEG EXPIRY", field: 'leg_no_2.expiry_date', valueFormatter: params => params.data.leg_no_2?.expiry_date },
            // { headerName: "SECOND LEG PRICE", field: 'leg_no_2.order_price', valueFormatter: params => params.data.leg_no_2?.order_price },
            { headerName: "EXCHANGE ORDER NO", field: "leg_no_1.exchange_order_no", filter: 'agNumberColumnFilter' },
            { headerName: "INITIATED FROM", field: "initiated_by" },
            { headerName: "MODIFIED FROM", field: "modified_by" },
        ];
        dispatch(getSpreadOrderColumnDefsSuccess(objResp));
    } catch (error) {
        console.error(error);
        dispatch(getSpreadOrderColumnDefsFailure([]));

    }


};
export const getSpreadOrderColumnDefsSuccess = (payload) => {
    return { type: ORDERS.GET_SPREAD_ORDER_COLUMNDEFS_SUCCESS, payload: payload };

};
export const getSpreadOrderColumnDefsFailure = (payload) => {
    return { type: ORDERS.GET_SPREAD_ORDER_COLUMNDEFS_SUCCESS, payload: payload };

};
/*Parshva S: 26-10-2023 : BT-120114 - Breeze - Order Book - Spread - end*/

export const getMultiScriptSecongLeg = (Payload) => async (dispatch) => {
    const resp = await getSriptForSecondLeg(Payload);

    const secondLeg = resp.data.data;
    // Ajitesh 06-06-2024 Call success or failure to set apt data for multileg data in redux
    secondLeg ? dispatch(getMultiScriptSecongLegSuccess(secondLeg)) : dispatch(getMultiScriptSecongLegFailure({}));
};

export const getMultiScriptSecongLegSuccess = (resp) => {
    return { type: ORDERS.GET_MUITISCRIPT_SECONDLEG_SUCCESS, payload: resp };

};
export const getMultiScriptSecongLegFailure = (payload) => {
    return { type: ORDERS.GET_MUITISCRIPT_SECONDLEG_FAILURE, payload };

};


export const placeMultilegOrderAction = (payloadOrderMultileg) => async (dispatch) => {
    /*
    Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - Start
    */
    try {
        dispatch(orderEntryApiPending(true));
        const objResp = await placeMultilegOrder(payloadOrderMultileg);
        dispatch(getplaceMultilegOrderSuccess(objResp));
        return Promise.resolve(objResp);

    } catch (error) {
        console.error(error);
        dispatch(getplaceMultilegOrderFailure([]));
        return Promise.reject(error);

    } finally {
        dispatch(orderEntryApiPending(false));
    }
    /*
    Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - End
    */
};

export const getplaceMultilegOrderSuccess = (objResp) => {
    return { type: ORDERS.GET_PLACE_MULTILEG_ORDER_SUCESS, payload: objResp };
};

export const getplaceMultilegOrderFailure = (payload) => {
    return { type: ORDERS.GET_PLACE_MULTILEG_ORDER_FAILURE, payload };
};

export const getMultiLegData = (payload) => {
    return { type: ORDERS.MULTI_LEG_DATA, payload };
};

export const getSpreadOrder = (payloadSpreadOrder) => async (dispatch) => {
    try {
        const objResp = await getSpreadOrderInfo(payloadSpreadOrder);
        dispatch(getSpreadOrderSuccess(objResp?.data?.data));
        return Promise.resolve(objResp);
    } catch (error) {
        console.error(error);
        dispatch(getSpreadOrderFailure([]));
    }
};


export const updateSpreadInfoForBrokerage = (payload) => {
    return { type: ORDERS.UPDATE_SPREAD_INFO_FOR_BROKERAGE, payload };
};

export const getSpreadOrderSuccess = (objResp) => {
    return { type: ORDERS.GET_SPREAD_ORDER_SUCESS, payload: objResp };
};

export const getSpreadOrderFailure = (payload) => {
    return { type: ORDERS.GET_SPREAD_ORDER_FAILURE, payload };
};
export const placeMultiScriptOrderCarts = (objpayload) => async (dispatch) => {
    // {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - Start */ }
    dispatch(orderEntryApiPending(true));
    try {
        const res = await placeMultiScriptOrderCart(objpayload);
        dispatch(placeMultiScriptOrderCartSuccess(res));
    }
    catch (error) {
        console.error(error);
        dispatch(placeMultiScriptOrderCartFailure([]));
    } finally {
        dispatch(orderEntryApiPending(false));
    }
    // {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - End */ }
};

export const placeMultiScriptOrderCartSuccess = (resp) => {
    return { type: ORDERS.PLACE_MULTISCRIPT_ORDERCART_SUCCESS, payload: resp };
};
export const placeMultiScriptOrderCartFailure = (payload) => {
    return { type: ORDERS.PLACE_MULTISCRIPT_ORDERCART_FAILURE, payload };
};


export const orderCartMultiScripts = (objpayload) => async (dispatch) => {
    // {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - Start */ }
    try {
        dispatch(orderEntryApiPending(true));
        const res = await orderCartMultiScript(objpayload);
        dispatch(orderCartMultiScriptsSuccess(res));
    }
    catch (error) {
        console.error(error);
        dispatch(orderCartMultiScriptsFailure([]));
    } finally {
        dispatch(orderEntryApiPending(false));
    }
    // {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - End */ }
};

export const orderCartMultiScriptsSuccess = (resp) => {
    return { type: ORDERS.ORDERCART_MULTISCRIPT_SUCCESS, payload: resp };
};
export const orderCartMultiScriptsFailure = (payload) => {
    return { type: ORDERS.ORDERCART_MULTISCRIPT_FAILURE, payload };
};

export const getSipOrderFrequency = (payload) => {
    return { type: ORDERS.GET_SIP_ORDER_FREQUENCY, payload };
};
// Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders Start
export const getAllMultiScripOrders = (objMultiLegOrderPayload) => async (dispatch, getState) => {
    dispatch(isMultilegOrdersLoading(true));
    let { orderStatus } = objMultiLegOrderPayload;
    let arrMultiLeg = [];
    let resp = [];
    let allOrders = [];

    const productTypeData = getState()?.orders?.productTypes;
    const objLoginSession = getState()?.auth?.objLoginSession;
    arrMultiLeg = await getUserMultiScripOrders({ ...objMultiLegOrderPayload, orderType: 'multileg' });
    if (arrMultiLeg?.data)
        resp.push(...arrMultiLeg?.data?.data);
    if (resp.length > 0) {
        // Calls api to get additional trade info for all orders using order_id to be shown when user clicks ">" icon in table in orderbook
        let temp = await _getTradeOrders({ offSet: 1, limit: 100, order_ids: resp.map(element => element.order_id).toString() });
        allOrders = resp?.map((el) => {
            return {
                ...el,
                expandCell: '', orderNo: el.order_id, prod_type: _getProductType(el.leg_no_1.product_type, el.exchange, productTypeData, objLoginSession),
                additionalData: temp.data.length ? temp?.data?.filter((tradeApiInfo) => el.order_id === tradeApiInfo.order_id) : [] // Adds extra additional info field and all the order and trade info is now included directly after inital api call for orders
            };
        });
    }
    /* arrOpenOrders = allOrders?.filter((element) => element.status === ALL_ORDERS_STATUS.ORDER_STATUS_PENDING || element.status === ALL_ORDERS_STATUS.ORDER_STATUS_OMS_XMITTED || element.status === ALL_ORDERS_STATUS.ORDER_STATUS_AMOACCEPTED);
    arrCompletedOrders = allOrders?.filter((element) => element.status === ALL_ORDERS_STATUS.ORDER_STATUS_EXECUTED);
    dispatch(getAllMultiLegOrderSuccess({
        allOrders: allOrders,
        allCompletedOrders: arrCompletedOrders,
        allOpenOrders: arrOpenOrders
    })); */
    switch (orderStatus) {
        case ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS: {
            if (arrMultiLeg?.data?.status) {
                if (+objMultiLegOrderPayload.offSet > 1) {
                    if (arrMultiLeg?.data?.data.length > 0) {
                        dispatch(updateMultilegAllOrders(allOrders));
                    } else {
                        dispatch(updateMultilegAllOrders([]));
                    }
                } else {
                    dispatch(getAllMultilegOrdersSuccess(allOrders));
                    dispatch(setCurrentPage(1));
                }
                dispatch(getAllMultilegOrdersLength(arrMultiLeg?.data?.metadata?.all_records));
                dispatch(getOpenMultilegOrdersLength(arrMultiLeg?.data?.metadata?.open_records));
                dispatch(getCompletedMultilegOrdersLength(arrMultiLeg?.data?.metadata?.completed_records));
            }
            else {
                dispatch(getAllMultilegOrderFailure([]));
                dispatch(getAllMultilegOrdersLength(0));
            }
            break;
        }
        case ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS: {
            if (arrMultiLeg?.data?.status) {
                if (+objMultiLegOrderPayload?.offSet > 1) {
                    if (arrMultiLeg?.data?.data.length > 0) {
                        dispatch(updateMultilegOpenOrders(allOrders));
                    } else {
                        dispatch(updateMultilegOpenOrders([]));
                    }
                } else {
                    dispatch(getAllMultilegOpenOrderSuccess(allOrders));
                    dispatch(setCurrentPage(1));
                }
                dispatch(getAllMultilegOrdersLength(arrMultiLeg?.data?.metadata?.all_records));
                dispatch(getOpenMultilegOrdersLength(arrMultiLeg?.data?.metadata?.open_records));
                dispatch(getCompletedMultilegOrdersLength(arrMultiLeg?.data?.metadata?.completed_records));
            } else {
                dispatch(getAllMultilegOpenOrderFailure([]));
                dispatch(getOpenMultilegOrdersLength(0));
            }
            break;
        }
        case ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS: {
            if (arrMultiLeg?.data?.status) {
                if (+objMultiLegOrderPayload?.offSet > 1) {
                    if (arrMultiLeg?.data?.data.length > 0) {
                        dispatch(updateMultilegCompletedOrders(allOrders));
                    } else {
                        dispatch(updateMultilegCompletedOrders([]));
                    }
                } else {
                    dispatch(getAllMultilegCompletedOrderSuccess(allOrders));
                    dispatch(setCurrentPage(1));
                }
                dispatch(getAllMultilegOrdersLength(arrMultiLeg?.data?.metadata?.all_records));
                dispatch(getOpenMultilegOrdersLength(arrMultiLeg?.data?.metadata?.open_records));
                dispatch(getCompletedMultilegOrdersLength(arrMultiLeg?.data?.metadata?.completed_records));
            } else {
                dispatch(getAllMultilegCompletedOrderFailure([]));
                dispatch(getCompletedMultilegOrdersLength(0));
            }
            break;
        }
        default:
            break;
    }
    setTimeout(() => {
        dispatch(isMultilegOrdersLoading(false));
    }, 1000);
};
export const getAllSpreadOrders = (objMultiLegOrderPayload) => async (dispatch, getState) => {
    dispatch(isSpreadOrdersLoading(true));
    let arrSpread = [];
    const productTypeData = getState()?.orders?.productTypes;
    const objLoginSession = getState()?.auth?.objLoginSession;
    let { orderStatus } = objMultiLegOrderPayload;
    arrSpread = await getUserMultiScripOrders({ ...objMultiLegOrderPayload, orderType: 'spread' });
    let data = arrSpread?.data?.data?.map((el) => {
        return {
            ...el, expandCell: '', orderNo: el.order_id, prod_type: _getProductType(el.leg_no_1.product_type, el.exchange, productTypeData, objLoginSession), leg_indicator: "-", exchangeName: el.exchange === "NSE_CUR" ? "NSECDS" : el.exchange === "BSE_CUR" ? 'BSECDS' : el.exchange, decLocLength: (el?.leg_no_1?.price_tick / el?.leg_no_1?.dec_loc)?.toString()?.split('.')[1]?.length
        };
    });
    switch (orderStatus) {
        case ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS: {
            if (arrSpread?.data?.status) {
                if (+objMultiLegOrderPayload?.offSet > 1) {
                    if (data?.length > 0) {
                        dispatch(updateSpreadAllOrders(data));
                    } else {
                        dispatch(updateSpreadAllOrders([]));
                    }
                } else {
                    dispatch(getAllSpreadOrdersSuccess(data));
                    dispatch(setCurrentPage(1));

                }
                dispatch(getAllSpreadOrdersLength(arrSpread?.data?.metadata?.all_records));
                dispatch(getOpenSpreadOrdersLength(arrSpread?.data?.metadata?.open_records));
                dispatch(getCompletedSpreadOrdersLength(arrSpread?.data?.metadata?.completed_records));
            } else {
                dispatch(getAllSpreadOrderFailure([]));
                dispatch(getAllSpreadOrdersLength(0));
            }

            break;
        }
        case ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS: {
            if (arrSpread?.data?.status) {
                if (+objMultiLegOrderPayload?.offSet > 1) {
                    if (data?.length > 0) {
                        dispatch(updateSpreadOpenOrders(data));
                    } else {
                        dispatch(updateSpreadOpenOrders([]));
                    }
                } else {
                    dispatch(getAllSpreadOpenOrderSuccess(data));
                    dispatch(setCurrentPage(1));

                }
                dispatch(getAllSpreadOrdersLength(arrSpread?.data?.metadata?.all_records));
                dispatch(getOpenSpreadOrdersLength(arrSpread?.data?.metadata?.open_records));
                dispatch(getCompletedSpreadOrdersLength(arrSpread?.data?.metadata?.completed_records));
            } else {
                dispatch(getAllSpreadOpenOrderFailure([]));
                dispatch(getOpenSpreadOrdersLength(0));

            }

            break;
        }
        case ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS: {
            if (arrSpread?.data?.status) {
                if (+objMultiLegOrderPayload?.offSet > 1) {
                    if (data?.length > 0) {
                        dispatch(updateSpreadCompletedOrders(data));
                    } else {
                        dispatch(updateSpreadCompletedOrders([]));
                    }
                } else {
                    dispatch(getAllSpreadCompletedOrderSuccess(data));
                    dispatch(setCurrentPage(1));

                }
                dispatch(getAllSpreadOrdersLength(arrSpread?.data?.metadata?.all_records));
                dispatch(getOpenSpreadOrdersLength(arrSpread?.data?.metadata?.open_records));
                dispatch(getCompletedSpreadOrdersLength(arrSpread?.data?.metadata?.completed_records));
            } else {
                dispatch(getAllSpreadCompletedOrderFailure([]));
                dispatch(getCompletedSpreadOrdersLength(0));

            }
            break;
        }
        default:
            break;
    }
    if (arrSpread?.data?.status) {
        setTimeout(() => {
            dispatch(isSpreadOrdersLoading(false));
        }, 1000);

        return Promise.resolve({ status: arrSpread?.data?.status, data: arrSpread?.data?.data });
    } else {
        setTimeout(() => {
            dispatch(isSpreadOrdersLoading(false));
        }, 1000);
        return Promise.reject([]);
    }
    // if (arrSpread?.data)
    //     resp.push(...arrSpread?.data?.data);
    // if (resp.length > 0) {
    //     allOrders = resp?.map((el) => {
    //         return {
    //             ...el, expandCell: '', orderNo: el.order_id, prod_type: _getProductType(el.leg_no_1.product_type, el.exchange, productTypeData, objLoginSession), leg_indicator: "-", exchangeName: el.exchange === "NSE_CUR" ? "NSECDS" : el.exchange, decLocLength: (el?.leg_no_1?.price_tick / el?.leg_no_1?.dec_loc)?.toString()?.split('.')[1]?.length
    //         };
    //     });
    // }
    // arrOpenOrders = allOrders?.filter((element) => element.status === ALL_ORDERS_STATUS.ORDER_STATUS_PENDING || element.status === ALL_ORDERS_STATUS.ORDER_STATUS_OMS_XMITTED || element.status === ALL_ORDERS_STATUS.ORDER_STATUS_AMOACCEPTED || element.status === ALL_ORDERS_STATUS.ORDER_STATUS_OMSXMITTED);
    // arrCompletedOrders = allOrders?.filter((element) => element.status === ALL_ORDERS_STATUS.ORDER_STATUS_EXECUTED);
    // dispatch(getAllSpreadOrderSuccess({
    //     allOrders: allOrders,
    //     allCompletedOrders: arrCompletedOrders,
    //     allOpenOrders: arrOpenOrders
    // }));
    // Ajitesh 15/07/2024 Adds loader for spread order api


};
// Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders End
export const getAllMultiScripOrderSuccess = (resp) => {
    return { type: ORDERS.GET_ALL_MULTI_SCRIP_ORDER_SUCCESS, payload: resp };

};
export const getAllMultiScripOrderFailure = (payload) => {
    return { type: ORDERS.GET_ALL_MULTI_SCRIP_ORDER_FAILURE, payload };

};
export const getAllMultiLegOrderSuccess = (resp) => {
    return { type: ORDERS.GET_ALL_MULTI_LEG_ORDER_SUCCESS, payload: resp };

};
export const getAllMultiLegOrderFailure = (payload) => {
    return { type: ORDERS.GET_ALL_MULTI_LEG_ORDER_FAILURE, payload };

};


export const getAllGtdOrders = (objGtdOrderPayload) => async (dispatch, getState) => {

    dispatch(ordersApiPending(true));
    try {
        const arrProductTypeData = getState()?.orders?.productTypes;
        const objCFT = getState()?.auth?.objCFT;
        let optionalGTTOrGTD = 'gtd';
        if (objCFT?.GTTSUPPORT === FACILITY_NUM.ON) {
            optionalGTTOrGTD = 'gtt';
        }
        const objLoginSession = getState()?.auth?.objLoginSession;
        const { status, data = [], metadata = {} } = await _getGtdOrders(objGtdOrderPayload, arrProductTypeData, objLoginSession, optionalGTTOrGTD);
        const { orderStatus, offSet = 1 } = objGtdOrderPayload;
        switch (orderStatus) {
            case ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS: {
                if (offSet > 1) {
                    if (status && data?.length > 0) {
                        dispatch(updateAllGtdOrder(data));
                    } else {
                        dispatch(updateAllGtdOrder([]));
                    }
                } else {
                    dispatch(getAllGtdOrderSuccess(data));
                    dispatch(setCurrentPage(1));
                }
                dispatch(getGTDMetaData(metadata));
                break;
            }
            case ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS: {
                if (offSet > 1) {
                    if (status && data?.length > 0) {
                        dispatch(updateOpenGtdOrder(data));
                    } else {
                        dispatch(updateOpenGtdOrder([]));
                    }
                } else {

                    dispatch(getOpenGtdOrder(data));
                    dispatch(setCurrentPage(1));

                }
                dispatch(getGTDMetaData(metadata));
                break;
            }
            case ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS: {
                if (offSet > 1) {
                    if (status && data?.length > 0) {
                        dispatch(updateCompletedGtdOrder(data));
                    } else {
                        dispatch(updateCompletedGtdOrder([]));
                    }
                } else {

                    dispatch(getCompletedGtdOrder(data));
                    dispatch(setCurrentPage(1));

                }
                dispatch(getGTDMetaData(metadata));
                break;
            }
            default:
                break;
        }
        return Promise.resolve({ status, data });
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(ordersApiPending(false));

    }
};

export const getAllGtdOrderSuccess = (payload) => {
    return { type: ORDERS.GET_ALL_GTD_ORDER_SUCCESS, payload };
};

export const getOpenGtdOrder = (payload) => {
    return { type: ORDERS.GET_OPEN_GTD_ORDER, payload };
};

export const getCompletedGtdOrder = (payload) => {
    return { type: ORDERS.GET_COMPLETED_GTD_ORDER, payload };
};
export const updateAllGtdOrder = (payload) => {
    return { type: ORDERS.UPDATE_ALL_GTD_ORDER_SUCCESS, payload };
};

export const updateOpenGtdOrder = (payload) => {
    return { type: ORDERS.UPDATE_OPEN_GTD_ORDER, payload };
};

export const updateCompletedGtdOrder = (payload) => {
    return { type: ORDERS.UPDATE_COMPLETED_GTD_ORDER, payload };
};
export const getGTDMetaData = (payload) => {
    return { type: ORDERS.GET_GTD_META_DATA, payload };
};


export const getAllOpenOrders = (openOrderPayload) => async (dispatch, getState) => {
    try {
        dispatch(sideTrayOrdersApiPending(true));


        const arrOrderTypes = await deepClone(getState().orders.orderTypes);
        const objLoginSession = await deepClone(getState().auth.objLoginSession);
        const productTypes = await deepClone(getState().orders.productTypes);
        const objCFT = getState()?.auth?.objCFT;
        let optionalGTTOrGTD = 'gtd';
        if (objCFT?.GTTSUPPORT === FACILITY_NUM.ON) {
            optionalGTTOrGTD = 'gtt';
        }
        const objResp = await _getAllOpenOrders(openOrderPayload, objLoginSession, productTypes, optionalGTTOrGTD);

        if (objResp?.data) {

            //dispatch(getAllSipOrderSuccess(objResp?.data?.sipData));
            // dispatch(getAllOrdersSuccess(objResp?.data?.singleScripData));
            // dispatch(getAllMultiScripOrderSuccess(objResp?.data?.multiScripData));

            {/* Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start   */ }
            const { activeScripId = -1 } = openOrderPayload;
            if (activeScripId == 1 || activeScripId == -1) {
                arrOrderTypes[0].data = [...arrOrderTypes[0].data, ...objResp?.data?.singleScripData];
                arrOrderTypes[0].metadata = objResp?.metadata?.singleScripMetaData;
            }
            arrOrderTypes[1].data = [...arrOrderTypes[1].data, ...objResp?.data?.multiScripData];
            arrOrderTypes[1].metadata = objResp?.metadata?.multiScripMetaData;

            if (activeScripId == 3 || activeScripId == -1) {
                arrOrderTypes[2].data = [...arrOrderTypes[2].data, ...objResp?.data?.sipData];
                arrOrderTypes[2].metadata = objResp?.metadata?.sipMetaData;
            }

            if (activeScripId == 4 || activeScripId == -1) {
                arrOrderTypes[3].data = [...arrOrderTypes[3].data, ...objResp?.data?.gtdData];
                arrOrderTypes[3].metadata = objResp?.metadata?.gtdMetaData;
            }

            arrOrderTypes[4].data = [...arrOrderTypes[4].data, ...objResp?.data?.spreadData];
            arrOrderTypes[4].metadata = objResp?.metadata?.spreadMetaData;

            dispatch(getAllOpenOrdersSuccess(arrOrderTypes));
            dispatch(updateOrderTypes(arrOrderTypes));
            // dispatch(updateActiveOrders(arrOrderTypes[0]));
        } else { }
    } catch (error) {

    } finally {

        dispatch(sideTrayOrdersApiPending(false));

    }
};
// {/* Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End   */ }

export const getAllOpenOrdersSuccess = (arrOrderTypes) => {
    return { type: ORDERS.GET_ALL_OPEN_ORDER_SUCCESS, payload: arrOrderTypes };
};

export const getAllOpenOrdersFailure = (payload) => {
    return { type: ORDERS.GET_ALL_OPEN_ORDER_FAILURE, payload };
};

// Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start
export const clearAllOpenOrders = () => {
    return { type: ORDERS.CLEAR_ALL_OPEN_ORDERS };
};
// Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End

export const getOrderInfo = (payload) => {
    return { type: ORDERS.GET_ORDER_INFO, payload };
};

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

export const getLTPPriceBand = (objPayload) => async (dispatch) => {
    try {
        const resp = await _getLTPPriceBand(objPayload);
        if (resp?.status) {
            dispatch(getLTPPriceBandSuccess(resp?.data?.data));
        } else {
            dispatch(getLTPPriceBandFailure(null));
        }
    } catch (error) {
        console.error(error);
        dispatch(getLTPPriceBandFailure(null));
    }

};

export const getLTPPriceBandSuccess = (resp) => {
    return { type: ORDERS.GET_LTP_PRICE_BAND_SUCCESS, payload: resp };

};
export const getLTPPriceBandFailure = (payload) => {
    return { type: ORDERS.GET_LTP_PRICE_BAND_FAILURE, payload };

};

export const getMarketStatus = () => async (dispatch) => {
    try {
        const resp = await _getMarketStatus();
        if (resp?.status) {
            dispatch(getMarketStatusSuccess(resp?.data));
        } else {
            dispatch(getMarketStatusFailure([]));
        }
    } catch (error) {
        console.error(error);
        dispatch(getMarketStatusFailure([]));
    }

};

export const getMarketStatusSuccess = (payload) => {
    return { type: ORDERS.GET_MARKET_STATUS_SUCCESS, payload };

};
export const getMarketStatusFailure = (payload) => {
    return { type: ORDERS.GET_MARKET_STATUS_FAILURE, payload };

};


export const getMarginPlusParams = (objPayload) => async (dispatch) => {
    try {
        const resp = await _getMarginPlusParams(objPayload);
        if (resp?.status) {
            dispatch(getMarginPlusParamsSuccess(resp?.data?.result));
            return Promise.resolve(resp?.data?.result);
        } else {
            dispatch(getMarginPlusParamsFailure([]));
            return Promise.reject(resp?.data);
        }
    } catch (error) {
        console.error(error);
        dispatch(getMarginPlusParamsFailure([]));
    }

};

export const getMarginPlusParamsSuccess = (resp) => {
    return { type: ORDERS.GET_MARGIN_PLUS_PARAMS_SUCCESS, payload: resp };

};
export const getMarginPlusParamsFailure = (payload) => {
    return { type: ORDERS.GET_MARGIN_PLUS_PARAMS_FAILURE, payload };

};

export const getBannedScripStatus = (objPayload) => async (dispatch) => {
    try {
        const resp = await _getBannedScripStatus(objPayload);
        if (resp?.status) {
            dispatch(getBannedScripStatusSuccess(resp?.data?.result));
            return resp;
        } else {
            dispatch(getBannedScripStatusFailure([]));
        }
    } catch (error) {
        console.error(error);
        dispatch(getBannedScripStatusFailure([]));
    }

};
//BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025  - Start
export const getBannedScripsList = (objPayload) => async (dispatch) => {
    try {
        const resp = await _getBannedScripsList(objPayload);
        if (resp?.status) {
            let arrBannedlist = resp?.data?.result.filter(eachScrip => eachScrip.nBanFlag == 1);
            dispatch(getBannedScripsListSuccess(arrBannedlist));
        } else {
            dispatch(getBannedScripsListFailure([]));
        }
    } catch (error) {
        console.error(error);
        dispatch(getBannedScripStatusFailure([]));
    }

};
export const getBannedScripStatusSuccess = (payload) => {
    return { type: ORDERS.GET_BANNED_SCRIP_STATUS_SUCCESS, payload };

};
export const getBannedScripStatusFailure = (payload) => {
    return { type: ORDERS.GET_BANNED_SCRIP_STATUS_FAILURE, payload };

};
export const getBannedScripsListSuccess = (payload) => {
    return { type: ORDERS.GET_BANNED_SCRIP_LIST_SUCCESS, payload };

};
export const getBannedScripsListFailure = (payload) => {
    return { type: ORDERS.GET_BANNED_SCRIP_LIST_FAILURE, payload };

};
//BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025  - End
export const updateSingleScripOrderConfirmed = (payload) => {
    return { type: ORDERS.UPDATE_SINGLE_SCRIP_IS_ORDER_CONFIRMED, payload };

};
// Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
export const updateMultiLegOrderConfirmed = (payload) => {
    return { type: ORDERS.UPDATE_MULTI_LEG_IS_ORDER_CONFIRMED, payload };

};
export const updateSpreadOrderConfirmed = (payload) => {
    return { type: ORDERS.UPDATE_SPREAD_IS_ORDER_CONFIRMED, payload };

};
// Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End
export const cancelSingleScripOrder = (Payload) => async () => {
    try {
        const objResp = await cancelSingleOrders(Payload);
        return Promise.resolve(objResp);
    } catch (error) {
        return Promise.reject(error);

    }
};
export const cancelAllSingleScripOrder = (Payload) => async () => {
    try {
        const objResp = await cancelAllOrders(Payload);
        return Promise.resolve(objResp);
    } catch (error) {
        return Promise.reject(error);

    }
};
export const modifyOrder = (Payload, exchange, orderNo) => async (dispatch) => {
    try {
        const objResp = await modifysingleScripOrder(Payload, exchange, orderNo);
        return Promise.resolve(objResp);
    } catch (error) {
        if (error?.response?.data) {
            dispatch(placeSingleScripOrderFailure(error?.response?.data));
            return Promise.reject(error?.response?.data);
        } else {
            dispatch(placeSingleScripOrderFailure({}));
            return Promise.reject(error);
        }
    }
};
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start
export const modifyCoverOrder = (Payload, exchange, orderNo) => async (dispatch) => {
    try {
        const objResp = await modifyUserSingleScripCoverOrders(Payload, exchange, orderNo);
        return Promise.resolve(objResp);
    } catch (error) {
        if (error?.response?.data) {
            dispatch(placeSingleScripOrderFailure(error?.response?.data));
            return Promise.reject(error?.response?.data);
        } else {
            dispatch(placeSingleScripOrderFailure({}));
            return Promise.reject(error);
        }
    }
};
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End

//  Azeem K : 29-04-2025 : BREEZE-6539 - Breeze - Bracket Orders - Start
export const modifyBracketOrder = (Payload, exchange, orderNo) => async (dispatch) => {
    //LLD comment : async redux function for modify bracket order
    try {
        const objResp = await modifyUserSingleScripBracketOrders(Payload, exchange, orderNo);
        return objResp;
    } catch (error) {
        if (error?.response?.data) {
            dispatch(placeSingleScripOrderFailure(error?.response?.data));
            return error?.response?.data;
        } else {
            dispatch(placeSingleScripOrderFailure({}));
            return error;
        }

    }

};
//  Azeem K : 29-04-2025 : BREEZE-6539 - Breeze - Bracket Orders - End

// Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders Start
export const modifySpread = (payload, orderNo) => async (dispatch) => {
    try {
        dispatch(orderEntryApiPending(true));
        const objResp = await modifySpreadOrder(payload, orderNo);
        dispatch(getplaceMultilegOrderSuccess(objResp));
        return Promise.resolve(objResp);
    } catch (error) {
        if (error?.response?.data) {
            // dispatch(getSpreadOrderSuccess(error?.response?.data));
            dispatch(getplaceMultilegOrderSuccess(error));
            return Promise.reject(error?.response?.data);
        } else {
            // dispatch(getSpreadOrderFailure({}));
            return Promise.reject(error);
        }
    } finally {
        dispatch(orderEntryApiPending(false));
    }
};
// Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders End

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
//Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
export const getAllSingleScripOrdersLength = (payload) => {
    return { type: ORDERS.GET_ALL_SINGLE_SCRIP_ORDER_LENGTH, payload };
};
export const getOpenSingleScripOrdersLength = (payload) => {
    return { type: ORDERS.GET_OPEN_SINGLE_SCRIP_ORDER_LENGTH, payload };
};
export const getCompletedSingleScripOrdersLength = (payload) => {
    return { type: ORDERS.GET_COMPLETED_SINGLE_SCRIP_ORDER_LENGTH, payload };
};
export const updateSingleScripCompletedOrders = (payload) => {
    return { type: ORDERS.UPDATE_SINGLE_COMPLETED_ORDERS, payload: payload };
};
export const updateSingleScripAllOrders = (payload) => {
    return { type: ORDERS.UPDATE_SINGLE_ALL_ORDERS, payload: payload };
};
export const updateSingleScripOpenOrders = (payload) => {
    return { type: ORDERS.UPDATE_SINGLE_OPEN_ORDERS, payload: payload };
};
export const getAllSpreadOrdersLength = (payload) => {
    return { type: ORDERS.GET_ALL_SPREAD_ORDER_LENGTH, payload };
};
export const getOpenSpreadOrdersLength = (payload) => {
    return { type: ORDERS.GET_OPEN_SPREAD_ORDER_LENGTH, payload };
};
export const getCompletedSpreadOrdersLength = (payload) => {
    return { type: ORDERS.GET_COMPLETED_SPREAD_ORDER_LENGTH, payload };
};
export const updateSpreadAllOrders = (payload) => {
    return { type: ORDERS.UPDATE_SPREAD_ALL_ORDERS, payload: payload };
};
export const updateSpreadOpenOrders = (payload) => {
    return { type: ORDERS.UPDATE_SPREAD_OPEN_ORDERS, payload: payload };
};
export const updateSpreadCompletedOrders = (payload) => {
    return { type: ORDERS.UPDATE_SPREAD_COMPLETED_ORDERS, payload: payload };
};
export const getAllSpreadOrdersSuccess = (arrAllOrders) => {
    return { type: ORDERS.GET_ALL_SPREAD_ORDERS_SUCCESS, payload: arrAllOrders };
};

export const getAllSpreadOrderFailure = (arrAllOrders) => {
    return { type: ORDERS.GET_ALL_SPREAD_ORDERS_FAILURE, payload: arrAllOrders };
};

export const getAllSpreadOpenOrderSuccess = (payload) => {
    return { type: ORDERS.GET_OPEN_ORDERS_SPREAD_SUCCESS, payload: payload };
};
export const getAllSpreadOpenOrderFailure = (payload) => {
    return { type: ORDERS.GET_OPEN_ORDERS_SPREAD_FAILURE, payload: payload };
};
export const getAllSpreadCompletedOrderSuccess = (payload) => {
    return { type: ORDERS.GET_COMPLETED_SPREAD_ORDERS_SUCCESS, payload: payload };
};

export const getAllSpreadCompletedOrderFailure = (payload) => {
    return { type: ORDERS.GET_COMPLETED_SPREAD_ORDERS_FAILURE, payload: payload };
};

export const isSpreadOrdersLoading = (payload) => {
    return { type: ORDERS.MULTILEG_ORDERS_LOADING, payload: payload };
};


//Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start

export const getOpenSipOrdersSuccess = (payload) => {
    return { type: ORDERS.GET_OPEN_SIP_ORDERS_SUCCESS, payload: payload };

};
export const getOpenSipOrdersFailure = (payload) => {
    return { type: ORDERS.GET_OPEN_SIP_ORDERS_FAILURE, payload: payload };

};

export const getCompletedSipOrdersSuccess = (payload) => {
    return { type: ORDERS.GET_COMPLETED_SIP_ORDERS_SUCCESS, payload: payload };

};
export const getCompletedSipOrdersFailure = (payload) => {
    return { type: ORDERS.GET_COMPLETED_SIP_ORDERS_FAILURE, payload: payload };

};
export const updateAllSipOrders = (payload) => {
    return { type: ORDERS.UPDATE_ALL_SIP_ORDERS, payload: payload };

};

export const updateAllSipOrdersCount = (payload) => {
    return { type: ORDERS.GET_ALL_EQUITY_SIP_SCRIP_ORDER_LENGTH, payload };

};

export const updateOpenSipOrders = (payload) => {
    return { type: ORDERS.UPDATE_OPEN_SIP_ORDERS, payload: payload };

};
export const updateCompletedSipOrders = (payload) => {
    return { type: ORDERS.UPDATE_COMPLETED_SIP_ORDERS, payload: payload };

};
export const setCurrentPage = (payload) => {
    return { type: ORDERS.SET_CURRENT_PAGE, payload: payload };

};
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

//Ameersha N : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - Resetign scrip scrplot and trigger when a search scrip is selected - Start
export const updateResetScrip = (payload) => {
    return { type: ORDERS?.UPDATE_RESET_SCRIP, payload };
};
//Ameersha N : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - Resetign scrip scrplot and trigger when a search scrip is selected - End
// Azeem K : 22-02-2024 : BT-102298   BSEEQ OrderBook – Start
export const ordersApiPending = (active) => {
    return { type: ORDERS.ORDERS_API_PENDING, payload: active };
};
// Azeem K : 22-02-2024 : BT-102298   BSEEQ OrderBook – End

export const sideTrayOrdersApiPending = (active) => {
    return { type: ORDERS.SIDE_TRAY_ORDERS_API_PENDING, payload: active };
};
//Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start
export const isMultipleOrdersCancelnProcess = (active) => {
    return { type: ORDERS.IS_MULTIPLE_ORDERS_CANCEL_INPROCESS, payload: active };
};
//Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - End

//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry - Start
export const updateIsBuyOrSell = (payload) => {
    return { type: ORDERS?.UPDATE_BUY_SELL, payload };
};
//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry - End
//Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - Start
export const orderEntryApiPending = (active) => {
    return { type: ORDERS.ORDERS_ENTRY_API_PENDING, payload: active };
};
//Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - End
// Ajitesh 15-07-2024 Multiuleg pagination action functions start
export const getAllMultilegOrdersLength = (payload) => {
    return { type: ORDERS.GET_ALL_MULTILEG_ORDER_LENGTH, payload };
};
export const getOpenMultilegOrdersLength = (payload) => {
    return { type: ORDERS.GET_OPEN_MULTILEG_ORDER_LENGTH, payload };
};
export const getCompletedMultilegOrdersLength = (payload) => {
    // Ajitesh Calls correct action
    return { type: ORDERS.GET_COMPLETED_MULTILEG_ORDER_LENGTH, payload };
};
export const updateMultilegAllOrders = (payload) => {
    return { type: ORDERS.UPDATE_MULTILEG_ALL_ORDERS, payload: payload };
};
export const updateMultilegOpenOrders = (payload) => {
    return { type: ORDERS.UPDATE_MULTILEG_OPEN_ORDERS, payload: payload };
};
export const updateMultilegCompletedOrders = (payload) => {
    return { type: ORDERS.UPDATE_MULTILEG_COMPLETED_ORDERS, payload: payload };
};
export const getAllMultilegOrdersSuccess = (arrAllOrders) => {
    return { type: ORDERS.GET_ALL_MULTILEG_ORDERS_SUCCESS, payload: arrAllOrders };
};

export const getAllMultilegOrderFailure = (arrAllOrders) => {
    return { type: ORDERS.GET_ALL_MULTILEG_ORDERS_FAILURE, payload: arrAllOrders };
};

export const getAllMultilegOpenOrderSuccess = (payload) => {
    return { type: ORDERS.GET_OPEN_ORDERS_MULTILEG_SUCCESS, payload: payload };
};
export const getAllMultilegOpenOrderFailure = (payload) => {
    return { type: ORDERS.GET_OPEN_ORDERS_MULTILEG_FAILURE, payload: payload };
};
export const getAllMultilegCompletedOrderSuccess = (payload) => {
    return { type: ORDERS.GET_COMPLETED_MULTILEG_ORDERS_SUCCESS, payload: payload };
};

export const getAllMultilegCompletedOrderFailure = (payload) => {
    return { type: ORDERS.GET_COMPLETED_MULTILEG_ORDERS_FAILURE, payload: payload };
};

export const isMultilegOrdersLoading = (payload) => {
    return { type: ORDERS.MULTILEG_ORDERS_LOADING, payload: payload };
};
// Ajitesh 15-07-2024 Multiuleg pagination action functions end

export const setShowSideTrayPlaceOrder = (payload) => {
    return { type: ORDERS.SHOW_SIDETRAY_PLACE_ORDER, payload: payload };
};
export const setShowSideOrderConfirmation = (payload) => {
    return { type: ORDERS.SHOW_SIDETRAY_CONIRMATION_ORDER, payload: payload };
};
export const setShowSideTrayOrderstatus = (payload) => {
    return { type: ORDERS.SHOW_SIDETRAY_ORDER_STATUS, payload: payload };
};
//BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue - Start
export const updateSliceRequestInfo = (payload) => {
    return { type: ORDERS.UPDATE_ORDER_SLICE_REQUEST_DATA, payload };
};
//BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue - End

export const setCautionaryMessageFromPopup = (nUserResp, strMsg, marketSegmentId, token, symbol, buySell) => async (dispatch, getState) => {
    //Params:
    //nUserResp=> user's response 0 for no and 1 fr yes
    //strMsg => Surveillance Measure message from scrip master
    //marketSegmentId=> segment Id of scrips
    //token =>token of scrips
    const objLoginSession = deepClone(getState()?.auth?.objLoginSession);

    const objPayload = {
        uID: objLoginSession?.data?.user_id,
        gID: objLoginSession?.data?.others?.groupId,
        productName: productDetails.productName,
        type: nUserResp,
        mktSegId: marketSegmentId,
        tkn: token,
        msg: strMsg,
        //  Azeem K :05-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --Start
        // LLD Comment: will add two more keys in payload (buysell & symbol)
        symbol: symbol,
        buysell: buySell
        //  Azeem K :05-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --End
    };

    const objResp = setCautionaryMsgDetails(objPayload);

};
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start
export const updateExitOrderData = (payload) => {
    return { type: ORDERS.UPDATE_EXIT_ORDER_DATA, payload };

};
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End

{/* BREEZE-9316: Margin Shortfall: Ravi R: 11-07-2025: Shortfall amount action: Start */ }
export const updateShortfallAmount = (payload) => {
    return { type: ORDERS.UPDATE_SHORTFALL_AMOUNT, payload };
};

{/* BREEZE-9316: Margin Shortfall: Ravi R: 11-07-2025: Shortfall amount action: End */ }